import { JavelinaBaseClient } from './JavelinaBaseClient'

export class JavelinaClaimClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description returns a claim by claim number with service lines
     * @param {String} claimNumber the JV claim number
     */
    async getClaimByClaimNumber(claimNumber) {
        await this.createSecureAxiosInstance()

        const params = {
            claimNumber: claimNumber
        };

        let path = this.queryParamsToPathParams(params, `pureProxy/claim/claims`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns a claim list by claim numbers with service lines
     * @param {Array} claimNumberList the list of JV claim numbers
     */
    async getClaimByClaimNumberList(claimNumberList) {
        await this.createAxiosRetryInstance()

        try {
            const response = await this.axiosRetryInstance.get(`claims/readClaimByClaimNumberList`, {
                params: {
                    claimNumberList: claimNumberList.join(',')
                }
            });

            return response.data?.parsedResponse;
        }
        catch (e) {
            if (e && e.response) return { errorCode: e.response.status };

            return { errorCode: 500 };
        }
    }

    /**
     * @description returns a list of claimsby patientid
     * @param {String} patientId the JV employeeId or dependentId
     */
    async searchClaimsByPatientId(patientId) {
        await this.createSecureAxiosInstance();

        const params = {
            patientId: patientId
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/claim/searchClaims`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    async getAllClaimsByPatientId(patientId) {
        const response = await this.searchClaimsByPatientId(patientId);
        const results = await this.loopPaginationResults("AdjudicationResult", response);
        return results;
    };

    /**
     * @description returns an EOB document for a claim
     * @param {*} claimNumber the JV claim number
     * @param {*} entityType the entity type
     */
    async getEobByClaimNumberAndEntity(claimNumber, entityType) {
        await this.createSecureAxiosInstance({ 'accept': 'application/octet-stream', responseType: 'arraybuffer' })

        const params = {
            claimNumber: claimNumber,
            EntityType: entityType,
        };

        let path = this.queryParamsToPathParams(params, `pureProxy/document/getEOB`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    async getEobByClaimNumberPatient(claimNumber) {
        return await this.getEobByClaimNumberAndEntity(claimNumber, this.loadConstants().ENTITYTYPE.Patient);
    }

    async getEobByClaimNumberProvider(claimNumber) {
        return await this.getEobByClaimNumberAndEntity(claimNumber, this.loadConstants().ENTITYTYPE.Provider);
    }
}
